import React, { forwardRef } from 'react';
import InputWithVariablesMC from '../../../components/InputWithVariablesMC';
import ButtonMC from '../../../components/ButtonMC';
import DropdownMC from '../../../components/DropdownMC';
import IconMC from '../../../components/IconMC';

const WebhookJsonEditor = forwardRef(({
  t,
  availableColumns,
  showVariables,
  toggleVariables,
  variableOptions,
  filterVariables
}, ref) => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-6">
      <div className="tw-flex tw-flex-col tw-gap-1">
        <h3 className="tw-text-sm tw-font-semibold tw-text-gray-950 tw-mb-0">
          {t('webhook_body_title')}
        </h3>
        <p className="tw-text-xs tw-text-gray-700 tw-mb-0">
          {t('json_editor_subtitle')}
        </p>
      </div>

      <div className="tw-flex tw-flex-col tw-gap-2">
        <InputWithVariablesMC
          name="jsonBody"
          textarea
          rows={10}
          options={availableColumns}
          propertyListTitle={t('property_list.title')}
          propertyListPlaceholder={t('search_placeholder')}
          propertyListNoResults={t('property_list.no_results_message')}
          showFooter
          ref={ref}
          className="placeholder:!tw-text-gray-500 !tw-bg-white tw-resize-none"
          placeholder={`{\n  "first_name": "{{first_name}}",\n  "last_name": "{{last_name}}",\n  "email": "{{email}}"\n}`}
        />

        <div className="tw-flex tw-justify-between tw-items-center tw-relative">
          {!showVariables && (
            <span className="tw-text-xs tw-text-gray-700">
              {t('insert_variables_hint')}
            </span>
          )}
          <div className={`${showVariables ? 'tw-w-full' : ''}`}>
            {!showVariables ? (
              <ButtonMC
                text={t('add_variable_button')}
                variant="SECONDARY"
                outlined
                icon="plus-outline"
                onClick={toggleVariables}
                className="tw-w-fit"
                size="xs"
              />
            ) : (
              <div className="tw-flex tw-gap-2">
                <div className="tw-w-full">
                  <DropdownMC
                    id="variableSelector"
                    name="variableSelector"
                    options={variableOptions}
                    onSelect={(id) => {
                      const col = availableColumns.find(c => c[1] === id);
                      if (col) {
                        ref.current?.handleInsertVariable(col);
                        toggleVariables();
                      }
                    }}
                    filterOption={filterVariables}
                    search
                    placeholder={t('select_field_placeholder')}
                  />
                </div>
                <div className="tw-flex tw-justify-between tw-items-center tw-mb-1">
                  <button
                    type="button"
                    onClick={toggleVariables}
                    className="tw-text-gray-700 hover:tw-text-gray-700"
                  >
                    <IconMC name="close-outline" />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default WebhookJsonEditor;
